import { render } from "./ClientCallSquadTab.vue?vue&type=template&id=ab8d0d66"
import script from "./ClientCallSquadTab.vue?vue&type=script&lang=js"
export * from "./ClientCallSquadTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__